// A no-op fake cache shim for browser builds
module.exports = function() {
    return {
        get() {},
        set() {},
        has() { return false; },
        del() {},
        reset() {}
    };
};


//////////////////
// WEBPACK FOOTER
// ./stub-lru-cache.js
// module id = 146
// module chunks = 0